import { useDispatch, useSelector } from "react-redux";
import React, { useRef, useState } from "react";
import { updatePromoFields } from "../../../../store/slices/promoFormSlice";
import pen from "../../../../assets/icons/pen.png";

export default function PromoDuration() {
    const promoDays = useSelector((state) => state.promoForm.durationDays);
    const [isDay, setIsDay] = useState(false);
    const iday = useRef();
    const dispatch = useDispatch();

    const days = [1, 2, 3, 4, 5, 7, 10, 15, 27];

    const handleSelectDay = (day) => {
        dispatch(updatePromoFields({ durationDays: day }));
        if (iday.current) iday.current.value = day;
    };

    const handleCustomInput = (e) => {
        const value = parseInt(e.target.value);
        if (!isNaN(value) && value >= 1 && value <= 27) {
            dispatch(updatePromoFields({ durationDays: value }));
        }
    };

    return (
        <div className="w-full rounded-xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-xl">
            <div className={'mb-2 flex w-full flex-row pl-2'}>
                <div className={'rounded-lg border border-white/10 bg-white/[0.08] px-2 py-0.5 text-sm font-medium text-white/90'}>4 Promo time </div>
            </div>
            {/* кастомный input */}
            {isDay && (
                <input
                    ref={iday}
                    type="number"
                    onChange={handleCustomInput}
                    min={1}
                    max={27}
                    className="mb-4 h-[32px] w-full rounded-md border border-white/10 bg-white/[0.06] px-2 text-sm text-emerald-200 placeholder:text-white/35 transition focus:border-emerald-400/50 focus:outline-none"
                    placeholder="Enter days manually (1-27)"
                />
            )}

            {/* список дней и иконка редактирования */}
            <div className="flex flex-wrap gap-3">
                {days.map((value, index) => (
                    <div key={index} className="flex flex-col items-center">
                        <p className="text-[9px] text-accent mb-[2px]">
                            {value === 1 ? "min" : value === 27 ? "max" : "\u00A0"}
                        </p>
                        <button
                            onClick={() => handleSelectDay(value)}
                            className={`flex h-[28px] w-[62px] items-center justify-center rounded-md border border-border_square bg-fill text-[11px] text-accent transition hover:border-emerald-400/50 ${
                                promoDays === value ? "border-emerald-400/60" : ""
                            }`}
                        >
                            {value} {value === 1 ? "day" : "days"}
                        </button>
                    </div>
                ))}

                {/* кнопка "кастомный ввод" */}
                <div className="flex flex-col items-center">
                    <p className="text-[9px] text-accent mb-[2px]">&nbsp;</p>
                    <button
                        onClick={() => setIsDay(!isDay)}
                        className="flex h-[28px] w-[62px] items-center justify-center rounded-md border border-border_square bg-fill text-[11px] text-accent transition hover:border-emerald-400/50"
                    >
                        <img src={pen} className="w-[14px] h-[14px]" alt="edit" />
                    </button>
                </div>
            </div>
        </div>
    );
}
